import React from "react";
import { LinkButton } from "components/buttons/LinkButton";
import { Breadcrumbs } from "components/navigation";
import PropTypes from "prop-types";

export function Reseller({ breadcrumbs }) {
    return (
        <div className="row">
            <Breadcrumbs items={breadcrumbs} />
            <h1>Reseller Portal</h1>

            <LinkButton
                text="Reseller Settings"
                intent="primary"
                href="/reseller/settings"
            />
        </div>
    );
}

Reseller.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
};
